<script>
	import { onMount } from "svelte";
	import DetailsCard from "../../../components/DetailsCard/DetailsCard.svelte";
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import client from "../../../services/client";
	import SubmittedPictures from "./SubmittedPictures.svelte";
	import Tasks from "./Tasks.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { loading } from "../../../store/store";
	import { statusMapStr } from "src/utils/options";
	import AuditTrail from "./AuditTrail.svelte";
	export let jobId;

	let items = [
		{
			label: "Information",
			value: 1,
			component: DetailsCard,
		},
		{
			label: "Tasks",
			value: 2,
			component: Tasks,
		},
		{
			label: "Audit Trail",
			value: 3,
			component: AuditTrail,
		},
		{
			label: "Pre-Job Inspection",
			value: 4,
			component: SubmittedPictures,
		},
	];

	let detailData;

	async function fetchJobById() {
		try {
			loading.set(true);
			const response = await client(`/v1/jobs/${jobId}`, {
				method: "GET",
				version: "Tasking",
			});
			detailData = response.data;
			loading.set(false);
		} catch (error) {
			loading.set(false);
			console.error(error.response);
		}
	}
	onMount(async () => {
		await fetchJobById();
	});
</script>

{#if !detailData}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<div class="d-flex align-items-baseline">
			<div class="mx-1">
				<h5>{detailData.id}</h5>
			</div>
			<div class="mx-1">
				{@html statusMapStr[detailData.job.status]}
			</div>
		</div>
		<Tabs {items} {detailData} />
	</LoaderContainer>
{/if}
